export { default as ProductBrand } from './product-brand'
